// A child's colorway is derived from their id, so it never changes when a
// sibling is added or removed. (The old design keyed off :nth-child, which
// silently reassigned everyone's colour whenever the list shifted.)

export const COLORWAYS = [
  { name: 'FOREST', hex: '#56734D' },
  { name: 'STEEL',  hex: '#4A6B8A' },
  { name: 'VIOLET', hex: '#6B4D8E' },
  { name: 'BRICK',  hex: '#B13A2E' },
  { name: 'OCHRE',  hex: '#A8802E' },
  { name: 'TEAL',   hex: '#3E6B66' },
];

export function colorwayFor(id) {
  const n = COLORWAYS.length;
  const primary = COLORWAYS[id % n];
  const secondary = COLORWAYS[(id * 3 + 2) % n];
  return {
    primary,
    secondary: secondary.name === primary.name ? COLORWAYS[(id + 1) % n] : secondary,
  };
}

// The chip strip down the right edge of every box. The child's own two
// colours take the most height, so identity reads before the name does.
export function chipsFor(id) {
  const { primary, secondary } = colorwayFor(id);
  const rest = COLORWAYS.filter(c => c.name !== primary.name && c.name !== secondary.name);
  return [
    { hex: primary.hex, grow: 4 },
    { hex: secondary.hex, grow: 2 },
    ...rest.slice(0, 3).map(c => ({ hex: c.hex, grow: 1 })),
  ];
}

export function initialsFor(name) {
  return name.trim().slice(0, 2).toUpperCase();
}
